// Converte o detail de um erro (que pode ser array/objeto Pydantic 422) em string segura,
// evitando o React error #31 (objeto como filho).
export const errorMsg = (err) => {
  const d = err?.response?.data?.detail ?? err?.detail ?? err?.message;
  if (Array.isArray(d)) {
    return d.map((x) => (typeof x === 'string' ? x : (x?.msg || x?.message || JSON.stringify(x)))).join('; ');
  }
  if (typeof d === 'string') return d;
  if (d && typeof d === 'object') return d.msg || d.message || JSON.stringify(d);
  if (typeof err === 'string') return err;
  return 'Erro ao processar a solicitação. Tente novamente.';
};
